import React from "react";
import { Icon, Link } from "@chakra-ui/react";
import { AllowedIcons } from "../../constants/types";
import { IconMap, SocialLinksMap, accent } from "../../constants/constants";
import { MotionBox } from "./motion-chakra";

interface NavbarItemProps {
  iconType: AllowedIcons;
  key?: number;
}

// The icon alone has no text a screen reader can announce, so the link needs
// an explicit accessible name.
const accessibleNames: Record<AllowedIcons, string> = {
  instagram: "Instagram",
  linkedIn: "LinkedIn",
  email: "Email",
  github: "GitHub",
};

const IconWithLink: React.FC<NavbarItemProps> = ({ iconType, key }) => {
  return (
    <MotionBox
      key={key}
      whileHover={{
        scale: 1.2,
        rotate: 10,
        transition: { type: "spring", stiffness: 300 },
      }}
    >
      <Link
        href={SocialLinksMap[iconType]}
        isExternal
        aria-label={accessibleNames[iconType]}
      >
        <Icon
          as={IconMap[iconType]}
          aria-hidden="true"
          focusable="false"
          boxSize="1.5em"
          color="brand.muted"
          transition="color 0.2s ease"
          _hover={{ color: accent }}
        />
      </Link>
    </MotionBox>
  );
};

export default IconWithLink;
